import React from 'react';
import { Link } from 'react-router-dom';

type LinkWrapperProps = {
  children: React.ReactNode;
  url: string;
  className?: string;
  style?: React.CSSProperties;
  target?: '_self' | '_blank';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLAnchorElement>;
  replace?: boolean;
};

const LinkWrapper = React.forwardRef<HTMLAnchorElement, LinkWrapperProps>(({
 children, url, className = '', style, target = '_self', onClick, onMouseEnter, onMouseLeave, replace
}, ref) => {
  // Check if URL is a full URL (starts with http:// or https://)
  const isFullUrl = url.startsWith('http://') || url.startsWith('https://');

  // If it's a full URL, use regular anchor tag
  if (isFullUrl) {
    return (
      <a
        href={url}
        className={className}
        style={style}
        target={target === '_self' ? '_blank' : target}
        rel="noopener noreferrer"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={ref}
      >
        {children}
      </a>
    );
  }

  // For relative paths, use React Router Link
  return (
    <Link
      to={url}
      className={className}
      style={style}
      target={target}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      replace={replace}
    >
      {children}
    </Link>
);
});

LinkWrapper.displayName = 'LinkWrapper';

export default LinkWrapper;
